import ApiGenerator from './ApiGenerator';

export default ApiGenerator.process('investments');
